import { render, staticRenderFns } from "./ReindeerMakeover.vue?vue&type=template&id=733de82f&scoped=true&"
import script from "./ReindeerMakeover.js?vue&type=script&lang=js&"
export * from "./ReindeerMakeover.js?vue&type=script&lang=js&"
import style0 from "./ReindeerMakeover.css?vue&type=style&index=0&id=733de82f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733de82f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
